



























































import Vue from "vue";
import Landing from "@/components/Landing.vue";
import Blurb from "@/components/Blurb.vue";
import FAQ from "@/components/Faq_test.vue";
import AboutUsStats from "@/components/AboutStats.vue";
import Sponsors from "@/components/Sponsors.vue";
import Billboard from "@/components/Billboard.vue";

import B1 from "@/assets/cyber/B1.svg";
import B2 from "@/assets/cyber/B2.svg";
import B3 from "@/assets/cyber/B3.svg";
import B4 from "@/assets/cyber/B4.svg";
import B5 from "@/assets/cyber/B5.svg";
import B6 from "@/assets/cyber/B6.svg";
import B7 from "@/assets/cyber/B7.svg";
import BTest from "@/assets/cyber/B5 (1).svg";

// @ts-ignore
import VueScrollReveal from "vue-scroll-reveal";
import VueRellax from "vue-rellax";
import Navigation from "@/components/Navbar.vue";
import sponsors_data from "@/data/sponsors_data";

import MiddleBuilding from "@/new_assets/back_middle_building_designs 1.png";
import LeftBuilding from "@/new_assets/left_building.png";
import RightBuilding from "@/new_assets/right_building.png";
import RightBuildingDesigns from "@/new_assets/right_building_designs.png";
import LeftBuildingDesigns from "@/new_assets/left_building_designs.png";
import Metro from "@/new_assets/metro.svg";
import Bridge from "@/new_assets/bridge.svg";
import Logo from "@/new_assets/DH splash art.png";
import Background from "@/new_assets/background.svg";
import BB1 from "@/new_assets/billboard.svg";
import BB2 from "@/new_assets/billboard_2.svg";

Vue.use(VueScrollReveal);
Vue.use(VueRellax);

export default Vue.extend({
  name: "app",
  components: {
    AboutUsStats,
    Navigation,
    Blurb,
    Landing,
    Sponsors,
    Billboard,
    FAQ,
  },
  data() {
    return {
      MiddleBuilding,
      LeftBuilding,
      RightBuilding,
      RightBuildingDesigns,
      LeftBuildingDesigns,
      Metro,
      Bridge,
      Logo,
      Background,

      B1,
      B2,
      B3,
      B4,
      B5,
      B6,
      B7,
      BTest,

      BB1,
      BB2,

      sponsors_data,
      opacities_map: { color0: 0, color1: 1, color2: 2, color3: 3 },
      opacities: ["1", "1", "1", "1"],
      threshholds_map: {
        point0: 0,
        point1: 1,
        point2: 2,
        point3: 3,
        point4: 4,
      },
      threshholds: [0, 1400, 2800, 3600, 3900],
      th_mobile: [0, 1400, 2800, 3600, 4400],
      blurb1_text: `At DeltaHacks, we believe change comes from dreaming big. Each year we enable over 800 students from across North America, working hard over 24 hours, to bring their big ideas to life. Our team works diligently year round to provide a welcoming atmosphere to all of our participants. DeltaHacks gives you the platform to make an idea a reality, whether it be with a team, or on your own. Unleash your creativity and make something great, we'll handle the rest! Make big ideas a reality at DeltaHacks 8!`,
      blurb1_button: `DeltaHacks 8 DevPost`,
      blurb1_link: `https://deltahacks8.devpost.com/`,
      blurb2_text: `DeltaHacks is the annual hackathon for change, it's even in the name! The primary focus of DeltaHacks is to enable hackers from all over to make a change, whether it be in education, finance, health or any other field, we're extremely passionate about hacking to make a positive change! We work with McMaster University to welcome hackers of all levels, from the novice to the most experienced! We supply the food, venue, and workshops to provide even the most seasoned veterans with new experiences. Now in our 8th year running, DeltaHacks 8 is our biggest and best DeltaHacks yet. Join us this March and take part in an experience you won’t forget!`,
    };
  },
  methods: {
    isPreMobile: (): boolean => window.innerWidth <= 1250,
    isMobile: (): boolean => window.innerWidth <= 720,
    handleScroll() {
      const y = window.scrollY || window.pageYOffset;
      for (let i = 0; i < this.opacities.length; i++) {
        if (!this.isMobile()) {
          Vue.set(
            this.opacities,
            i,
            String(
              (y - this.threshholds[i + 1]) /
                -(this.threshholds[i + 1] - this.threshholds[i])
            )
          );
        } else {
          Vue.set(
            this.opacities,
            i,
            String(
              (y - this.th_mobile[i + 1]) /
                -(this.th_mobile[i + 1] - this.th_mobile[i])
            )
          );
        }
      }
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
});
